import { daysAgo, EmailEntityId } from "@sp-crm/core";
import { ContentFull } from "components/layout";
import { Spinner } from "components/ui/spinner";
import { useGetUserMailboxMessagesForEntityQuery } from "generated/graphql";
import React from "react";
import { useFeature } from "store/selectors/hooks";

interface MailboxSyncMessagesProps {
    entityId: EmailEntityId;
}

export const MailboxSyncMessages: React.FC<MailboxSyncMessagesProps> = props => {
    const enabled = useFeature("mailboxSync");

    const query = useGetUserMailboxMessagesForEntityQuery(
        { id: props.entityId },
        { enabled },
    );

    if (!enabled) {
        return null;
    }

    if (query.isLoading) {
        return <Spinner />;
    }

    return (
        <ul className="space-y-4">
            {query.data?.getUserMailboxMessagesForEntity.map(message => (
                <li key={message.id} className="space-y-2">
                    <ContentFull>
                        <div className="space-y-2">
                            <div className="text-lg font-bold">{message.subject}</div>

                            <div>
                                <span className="font-bold">From:</span>
                                <span>{`${message.from?.name} <${message.from?.email}>`}</span>
                            </div>
                            <div>
                                <span className="font-bold">To:</span>
                                {message.to
                                    .map(t => `${t.contact.name} <${t.contact.email}>`)
                                    .join(", ")}
                            </div>
                            <div>
                                <span className="font-bold">CC:</span>
                                {message.cc
                                    .map(c => `${c.contact.name} <${c.contact.email}>`)
                                    .join(", ")}
                            </div>
                            <div>
                                <span className="font-bold">BCC:</span>
                                {message.bcc
                                    .map(b => `${b.contact.name} <${b.contact.email}>`)
                                    .join(", ")}
                            </div>
                            <div className="text-sm text-gray-700">
                                {message.bodyPreview}
                            </div>
                            <div className="text-sm text-gray-500 italic">
                                received {daysAgo(message.receivedTimestamp)}
                            </div>
                        </div>
                    </ContentFull>
                </li>
            ))}
        </ul>
    );
};
